import { prisma, type User } from "database";
import {
  findUniqueWhiteLabelByCustomDomain,
  findUniqueWhiteLabelBySubdomain,
} from "database/services";
import { isSuperAdmin, isAdmin } from "../utils";
import { getSubdomain } from "@sajilni/utils/getSubdomain";
import type { AuthRequestLike } from "./request-like";

const linkUserToWhiteLabel = async (request: AuthRequestLike, user: User) => {
  // TODO: Implement this function
  const isSuperAdminOrAdmin = false;
  // isSuperAdmin(user.roles) || isAdmin(user.roles);
  const host = request.headers.get("host");

  if (isSuperAdminOrAdmin || !host) return;
  // Get hostname of request (e.g. demo.sajilni.com, demo.localhost:3000)
  const domain = host.replace(
    ".localhost:3000",
    `.${process.env["NEXT_PUBLIC_ROOT_DOMAIN"]}`
  );

  const subdomain = getSubdomain(domain);
  // if the subdomain is admin, then this is from the super admin dashboard login page!

  const currentWhiteLabel = subdomain
    ? await findUniqueWhiteLabelBySubdomain(subdomain)
    : await findUniqueWhiteLabelByCustomDomain(domain);

  await prisma.user.update({
    where: {
      id: user.id,
    },
    data: {
      accessibleWhiteLabelId: currentWhiteLabel?.id,
    },
  });
};

export default linkUserToWhiteLabel;
